<template>
    <div class="container">
        <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
        <div class="news-list">
            <h2 class="page-title">风控TV</h2>
            <ul>
                <li class="news-item" v-for="(item,index) in list" :key="item.id" @click="handleToDetail(item.id)">
                    <div class="img">
                        <div class="mask"></div>
                        <img :src="item.logo" alt="">
                    </div>
                    <p class="brief">
                        {{item.title}}
                    </p>
                </li>
            </ul>
            <!-- <div class="bottom clearfix">
                <div class="bottom-page">
                    {{currentPage}}
                </div>
                <div class="toggle-btn-wrapper fr">
                    <a herf="javascript:;" class="toggle-btn toggle-btn-left" :class="{disabled:currentPage <=1}" @click="handlePrev">
                        <Icon type="ios-arrow-back"></Icon>
                    </a>
                    <a herf="javascript:;" class="toggle-btn" :class="{disabled:currentPage >= totalPages}" @click="handleNext">
                        <Icon type="ios-arrow-forward"></Icon>
                    </a>
                </div>
            </div> -->
        </div>
        <div class="pagin">
            <Page :total="totalPages" :page-size="6" size="small" @on-change="handlePageChange"></Page>
        </div>
        <Bottom></Bottom>
        <!-- <div class="page">
            <div class="current">{{currentPage}}</div>
            <div class="bar"></div>
            <div class="total">{{totalPages}}</div>
        </div> -->
    </div>
</template>
<script>
import { articleListMixin } from '@/mixins/articleListMixin'

export default {
    name: 'riskManage',
    mixins: [articleListMixin],
    data() {
        return {
            articleType: 6,
        }
    },
    created() {
        this.$store.commit('changeIncludes', ['riskManage'])
    },
    beforeRouteLeave(to, from, next) {
        if (to.name.toLowerCase() !== 'articledetail') {
            this.$store.commit('changeIncludes', [])
            next()
        } else {
            next()
        }
    },
}
</script>
<style lang="less" scoped>
// @import url('../assets/css/news-list.less');
.container {
  width: 100%;
  padding-top: 1rem;
  height: 100%;
}
.page-title {
  font-family: PingFangSC-Regular;
  font-size: 0.38rem;
  color: #000000;
  font-weight: normal;
  // margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  text-align: center;
}
.news-list {
  width: 80%;
  margin: 0 auto;
  font-size: 0;
  min-height: 500px;
  ul {
    min-height: 300px;
  }
}
.news-item {
  width: 100%/3;
  margin-bottom: 0.5rem;
  display: inline-block;
  text-align: center;
  padding: 0 15px;
  cursor: pointer;
  &:hover {
    .mask {
      display: none;
    }
    .brief {
      color: #ff7d41;
    }
  }
  .img {
    position: relative;
  }
  .mask {
    background-color: #000;
    opacity: 0.5;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: auto;
  }
  .brief {
    margin-top: 0.15rem;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #333333;
    text-align: justify;
    letter-spacing: 0;
    line-height: 0.35rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 0.35rem;
  }
}

.toggle-btn-wrapper {
  position: absolute;
  right: 0;
  margin-bottom: 50px;
}
.toggle-btn {
  color: #343434;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    border: 2px solid #343434;
  }
  .ivu-icon {
    font-size: 30px;
  }
}

.bottom {
  position: relative;
  height: 0.72rem;
  // margin-top: 0.4rem;
  margin-bottom: 0.3rem;
}
.bottom-page {
  position: absolute;
  bottom: 0;
  left: 50%;
  background: #f5f5f5;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  width: 0.6rem;
  height: 0.36rem;
  text-align: center;
  line-height: 0.36rem;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
}
.toggle-btn-left {
  margin-right: 30px;
}
.page {
  position: fixed;
  top: 48%;
  left: 10px;
  z-index: 2018;
  font-size: 0.28rem;
  color: #000000;
  width: 0.2rem;
  text-align: center;
  > div {
    width: 0.38rem;
  }
  .bar {
    height: 2px;
    background: #9b9b9b;
  }
}
.page-dark {
  color: #333;
  .bar {
    background: #9b9b9b;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/RiskManage.vue